import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipVerticalCircle32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFlipVerticalCircle32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M19.598 24.029a8.8 8.8 0 0 0 0-16.059V5.394c4.419 1.5 7.6 5.68 7.6 10.606l-.014.576c-.237 4.674-3.34 8.59-7.586 10.03zm-4.783-21.23a1.2 1.2 0 0 1 2.4 0v26.4a1.2 1.2 0 0 1-2.4 0zM4.813 15.422c.236-4.674 3.34-8.59 7.585-10.03V7.97a8.8 8.8 0 0 0 0 16.06v2.576c-4.419-1.5-7.6-5.68-7.6-10.607z"
            />
        </svg>
    );
}
export default memo(IconFlipVerticalCircle32);
